import React, { useEffect, useState } from "react";
import ZapierLogo from "../Assets/images/zapier-logo.png";
import MakeLogo from "../Assets/images/make-logo.png";
import N8NLogo from "../Assets/images/n8n-logo.png";
import InfoIcon from "../Assets/svgs/InfoIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Loader } from "../Common/Loader";
import { SuccessModel } from "./SuccessModel";
import { ErrorModel } from "./ErrorModel";
import { externalIntegrationAuthorize } from "../Redux/Slice/Integration/ExternalIntegrationAuthorizeSlice";

const ApproveZapierIntegrationModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isN8nIntegration = location.pathname.includes("/authorize-n8n")
  const [currentQuery, setCurrentQuery] = useState({
    client_id: "",
    state: "",
    redirect_uri: "",
    response_type: "",
    scope: [],
    integration: "ZAPIER", // ZAPIER | MAKE
  });
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 3000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const redirectToZapier = (code) => {
    const baseUrl = currentQuery.redirect_uri;
    const queryParams = new URLSearchParams({
      code: code,
      state: currentQuery.state,
    }).toString();

    window.location.replace(`${baseUrl}?${queryParams}`);
  };

  const onClickAllow = async () => {
    const payload = {
      clientId: currentQuery.client_id,
      state: currentQuery.state,
    };
    setLoading(true);
    const result = await dispatch(externalIntegrationAuthorize(payload));
    if (
      externalIntegrationAuthorize.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setLoading(false);
      showSuccessMessage(`${isN8nIntegration ? "n8n" : currentQuery.integration == "MAKE" ? "Make" : "Zapier"} integration enabled successfully!`, () =>
        redirectToZapier(result?.payload?.data?.code)
      );
    } else {
      setLoading(false);
      showErrorMessage(
        result?.payload?.error?.message ?? result?.payload?.data?.message
      );
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const client_id = urlParams.get("client_id");
    const state = urlParams.get("state");
    const redirect_uri = urlParams.get("redirect_uri");
    const response_type = urlParams.get("response_type");
    const scope = urlParams.get("scope");
    setCurrentQuery({
      client_id,
      state,
      redirect_uri,
      response_type,
      scope: scope?.split(","),
      integration:
        redirect_uri?.includes("integromat.com") ||
        redirect_uri?.includes("make.com")
          ? "MAKE"
          : "ZAPIER",
    });
  }, [navigate]);

  return loading ? (
    <Loader />
  ) : successModal.visible ? (
    <SuccessModel message={successModal.message} />
  ) : errorModal.visible ? (
    <ErrorModel message={errorModal.message} />
  ) : (
    <div className="modal modal--zapierModal modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__body  modal-body-left">
            <div className="zapierDetail">
              <div className="zapierDetail__logo">
                <img
                  src={
                    isN8nIntegration ? N8NLogo : currentQuery.integration == "MAKE" ? MakeLogo : ZapierLogo
                  }
                  alt="Zapier Logo"
                />
              </div>
              <h1 className="title tit--h3">
                You are giving{" "}
                {isN8nIntegration ? "n8n" : currentQuery.integration == "MAKE" ? "Make" : "Zapier"}{" "}
                permissions to:
              </h1>
              <div className="zapierDetail__info">
                <div className="form__checkbox form__checkbox--gray">
                  {currentQuery?.scope?.map((scope, index) => (
                    <div
                      key={`${scope}-checkbox-${index}`}
                      className="form__checkbox__option"
                    >
                      <input
                        type="checkbox"
                        id={`${scope}-checkbox-${index}`}
                        disabled
                        checked
                        className="form__checkbox__input"
                      />
                      <label
                        htmlFor={`${scope}-checkbox-${index}`}
                        className="form__checkbox__label"
                      >
                        View & edit {scope}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="zapierInfo">
                <div className="icon">
                  <InfoIcon />
                </div>
                <p className="para">
                  Make sure you trust{" "}
                  {isN8nIntegration ? "n8n" : currentQuery.integration == "MAKE" ? "make" : "zapier"}{" "}
                  <span>
                    you may be sharing sensitive info with this site or app.
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={() => navigate("/")}>
                Cancel
              </button>
              <button className="btn btn__primary" onClick={onClickAllow}>
                Allow
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default ApproveZapierIntegrationModal;
